import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as S from './styles';
import PanelContainer from './PanelContainer';
import MainContainer from './MainContainer';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

const OrderMonitor: React.FC = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const orderId = query.get('orderId');

  const [selectedOrderId, setSelectedOrderId] = useState<number | string | null>(
    orderId ? +orderId : null,
  );

  const { rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  const hasPermission = useCallback(
    (): boolean => findRotinas('monitor_de_pedidos')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/historico');
    }
  }, [addToast, hasPermission, history, rotinas]);

  return (
    <S.Container>
      <PanelContainer
        selectedOrderId={selectedOrderId}
        setSelectedOrderId={setSelectedOrderId}
      />
      <S.DividerVertical />
      <MainContainer
        selectedOrderId={selectedOrderId}
        setSelectedOrderId={setSelectedOrderId}
      />
    </S.Container>
  );
};

export default OrderMonitor;
